var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21C14.8807 21 16 19.8807 16 18.5C16 17.1193 14.8807 16 13.5 16C12.1193 16 11 17.1193 11 18.5C11 19.8807 12.1193 21 13.5 21Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17C19.3807 17 20.5 15.8807 20.5 14.5C20.5 13.1193 19.3807 12 18 12C16.6193 12 15.5 13.1193 15.5 14.5C15.5 15.8807 16.6193 17 18 17Z",
    fill: "#5F5F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C25.3807 17 26.5 15.8807 26.5 14.5C26.5 13.1193 25.3807 12 24 12C22.6193 12 21.5 13.1193 21.5 14.5C21.5 15.8807 22.6193 17 24 17Z",
    fill: "#5F5F5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 21C29.8807 21 31 19.8807 31 18.5C31 17.1193 29.8807 16 28.5 16C27.1193 16 26 17.1193 26 18.5C26 19.8807 27.1193 21 28.5 21Z",
    fill: "#5F5F5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3399 23.86C25.4699 22.84 24.7399 21.97 23.8599 20.95C23.3999 20.41 22.8099 19.87 22.1099 19.63C21.9999 19.59 21.8899 19.56 21.7799 19.54C21.5299 19.5 21.2599 19.5 20.9999 19.5C20.7399 19.5 20.4699 19.5 20.2099 19.55C20.0999 19.57 19.9899 19.6 19.8799 19.64C19.1799 19.88 18.5999 20.42 18.1299 20.96C17.2599 21.98 16.5299 22.85 15.6499 23.87C14.3399 25.18 12.7299 26.63 13.0299 28.66C13.3199 29.68 14.0499 30.69 15.3599 30.98C16.0899 31.13 18.4199 30.54 20.8999 30.54H21.0799C23.5599 30.54 25.8899 31.12 26.6199 30.98C27.9299 30.69 28.6599 29.67 28.9499 28.66C29.2599 26.62 27.6499 25.17 26.3399 23.86V23.86Z",
    fill: "#5F5F5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalIcon);
export default __webpack_public_path__ + "static/media/animalIcon.948acdb71daf0d465a85bf80bbaa9ab3.svg";
export { ForwardRef as ReactComponent };